const smoothScroll = () => {
  // ページ読み込み時にハッシュがあればスクロール
  $(document).ready(function () {
    const urlHeaderHeight = 0;
    const urlHash = location.hash;

    if (urlHash) {
      $('body,html').stop().scrollTop(0);

      setTimeout(() => {
        scrollToAnchor(urlHash, urlHeaderHeight);
      }, 0);
    }
  });

  const scrollToAnchor = (hash, headerHeight) => {
    const duration = 500; // アニメーション速度を調整
    const target = $(hash);
    if (!target.length) return; // ターゲットが存在しない場合は終了

    // BootstrapのCSS scroll-behavior:smoothとjQuery animateの二重動作を防ぐ
    document.documentElement.style.scrollBehavior = 'auto';
    document.body.style.scrollBehavior = 'auto';

    const position = target.offset().top - headerHeight;

    $('html, body')
      .stop()
      .animate({ scrollTop: position }, duration, 'linear', () => {
        const diff = target.offset().top - headerHeight;
        if (diff !== position) {
          $('html, body').animate({ scrollTop: diff }, 10, 'linear');
        }
      });
  };

  // 通常のクリックイベントでの処理
  $('a[href^="#"]:not([class*="js-nomove"])').on('click', function (e) {
    e.preventDefault();

    const headerHeight = 0;
    const href = $(this).attr('href');
    const hash = href === '#' || href === '' ? 'html' : href;

    scrollToAnchor(hash, headerHeight);
  });
};

const init = () => {
  smoothScroll();
};

export default { init, smoothScroll };
